// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"633":"d648f00f2c52549f","896":"ee6f5bfd61b3f999"}[chunkId] + ".js";
};